"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InGroupWidget = exports.Widget = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const Text_1 = __importDefault(require("../survey/Text"));
const InfoMap_1 = __importDefault(require("../survey/InfoMap"));
const Button_1 = __importDefault(require("../survey/Button"));
const Question_1 = __importDefault(require("../survey/Question"));
const GroupWidgets_1 = require("../survey/GroupWidgets");
const SurveyContext_1 = require("../../contexts/SurveyContext");
// BaseWidget is a wrapper around the SingleWidget component that is responsible
// for setting the default values of some fields when the widget is not part of
// a group
const Widget = (props) => {
    const surveyContext = react_1.default.useContext(SurveyContext_1.SurveyContext);
    const widgetConfig = surveyContext.widgets[props.currentWidgetShortname];
    const widgetStatus = (0, get_1.default)(props.interview, `widgets.${props.currentWidgetShortname}`, {});
    return (react_1.default.createElement(SingleWidget, Object.assign({}, props, { path: widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.path, customPath: widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.customPath, widgetStatus: widgetStatus, groupedObjectId: "", parentObjectIds: {} })));
};
exports.Widget = Widget;
// BaseInGroupWidget is a wrapper around the SingleWidget component that is
// responsible for setting the default values of some fields when the widget is
// part of a group
const InGroupWidget = (props) => {
    const surveyContext = react_1.default.useContext(SurveyContext_1.SurveyContext);
    const widgetConfig = surveyContext.widgets[props.currentWidgetShortname];
    const widgetStatus = (0, get_1.default)(props.interview, `${props.widgetStatusPath}.${props.currentWidgetShortname}`, {});
    // Get the paths with prefix if it exists
    const widgetPath = props.pathPrefix && (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.path) ? `${props.pathPrefix}.${widgetConfig.path}` : undefined;
    const widgetCustomPath = props.pathPrefix && (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.customPath)
        ? `${props.pathPrefix}.${widgetConfig.customPath}`
        : undefined;
    return (react_1.default.createElement(SingleWidget, Object.assign({}, props, { path: widgetPath, customPath: widgetCustomPath, widgetStatus: widgetStatus, groupedObjectId: props.groupedObjectId, parentObjectIds: props.parentObjectIds })));
};
exports.InGroupWidget = InGroupWidget;
/**
 * This is a single widget with all necessary properties to render it.
 */
const SingleWidget = (props) => {
    const surveyContext = react_1.default.useContext(SurveyContext_1.SurveyContext);
    const widgetShortname = props.currentWidgetShortname;
    surveyHelper.devLog('%c rendering widget ' + widgetShortname, 'background: rgba(0,255,0,0.1);');
    const widgetConfig = surveyContext.widgets[widgetShortname];
    if (widgetConfig === undefined) {
        console.error(`Widget is undefined: ${widgetShortname}`);
        if (surveyContext.devMode) {
            return (react_1.default.createElement("div", { className: "apptr__form-container two-columns question-invalid" }, `Widget is undefined: ${widgetShortname}`));
        }
        return null;
    }
    const path = props.path
        ? surveyHelper.interpolatePath(props.interview, props.path)
        : `${props.sectionName}.${widgetShortname}`;
    const customPath = props.customPath ? surveyHelper.interpolatePath(props.interview, props.customPath) : undefined;
    // FIXME This should be typed and correctly got from the interview
    // FIXME 2 This component should be responsible to check the isVisible status and return null instead of each widget individually
    const widgetStatus = props.widgetStatus;
    const [isServerValid, serverErrorMessage] = props.errors && props.errors[path] ? [false, props.errors[path]] : [true, undefined];
    // Overwrite widget status with server validation data if invalid
    if (!isServerValid) {
        widgetStatus.isValid = false;
        widgetStatus.errorMessage = widgetStatus.errorMessage || serverErrorMessage;
    }
    const widgetProps = {
        // TODO: type default props
        path: path,
        customPath: customPath,
        key: path,
        shortname: widgetShortname,
        loadingState: props.loadingState,
        groupedObjectId: props.groupedObjectId,
        widgetConfig: widgetConfig,
        widgetStatus: widgetStatus,
        section: props.sectionName,
        interview: props.interview,
        user: props.user,
        startUpdateInterview: props.startUpdateInterview,
        startAddGroupedObjects: props.startAddGroupedObjects,
        startRemoveGroupedObjects: props.startRemoveGroupedObjects,
        startNavigate: props.startNavigate
    };
    switch (widgetConfig.type) {
        case 'text':
            return react_1.default.createElement(Text_1.default, Object.assign({}, widgetProps));
        case 'infoMap':
            return react_1.default.createElement(InfoMap_1.default, Object.assign({}, widgetProps));
        case 'button':
            return react_1.default.createElement(Button_1.default, Object.assign({}, widgetProps));
        case 'question': {
            // check for joined widgets:
            const nextWidgetConfig = props.nextWidgetShortname
                ? surveyContext.widgets[props.nextWidgetShortname]
                : undefined;
            const nextWidgetStatus = nextWidgetConfig
                ? (0, get_1.default)(props.interview, `widgets.${props.nextWidgetShortname}`, {})
                : undefined;
            const join = nextWidgetStatus &&
                ((nextWidgetConfig.joinWith === widgetShortname && nextWidgetStatus.isVisible) ||
                    (widgetConfig.joinWith === props.nextWidgetShortname && nextWidgetStatus.isVisible));
            widgetProps.join = join;
            return react_1.default.createElement(Question_1.default, Object.assign({}, widgetProps));
        }
        case 'group':
            return (react_1.default.createElement(GroupWidgets_1.Group, Object.assign({}, widgetProps, { parentObjectIds: props.parentObjectIds, shortname: widgetShortname, errors: props.errors })));
    }
};
//# sourceMappingURL=Widget.js.map